import cn from 'classnames';
import { ReactElement, ReactNode } from 'react';
import './Card.css';

interface Props {
    children: ReactNode;
    title: string;
    icon?: ReactElement;
	className?: string;
	headerStyle?: string;
}

const Card = ({ title, children, icon, className, headerStyle }: Props) => {
	return (
		<div className={cn('card h-auto', className)}>
			<div className='card__header'>
                {icon}
				<h2 className={cn(headerStyle)}>{title}</h2>
			</div>
			<div className='pt-5'>
                { children }
			</div>
		</div>
	);
};

export default Card;
